export default __webpack_public_path__ + "static/media/menu-banner-02.2091c884.jpg";